import { CollectionEntity } from "@busy-human/gearbox";
export var CallRequest;
(function (CallRequest) {
    function Default() {
        return {
            unitId: '',
            incidentId: '',
            callerId: '',
            requestedAt: new Date().toISOString(),
            acknowledgedAt: null,
            acknowledgedBy: null,
            unitETA: null,
            status: 'pending',
        };
    }
    CallRequest.Default = Default;
    class CollectionClass extends CollectionEntity {
        defaults = Default;
        relationships = {};
    }
    CallRequest.CollectionClass = CollectionClass;
})(CallRequest || (CallRequest = {}));
//# sourceMappingURL=index.js.map